/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {SbCardComponent as ɵb} from './exampler/sb-card/sb-card.component';
export {SbCardModule as ɵa} from './exampler/sb-card/sb-card.module';
export {SbIconComponent as ɵd} from './exampler/sb-icons/sb-icon.component';
export {SbIconsModule as ɵc} from './exampler/sb-icons/sb-icons.module';